
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Downloads2 } from "@components/download2";
import { Downloads3 } from "@components/download3";
import { NextSeo } from "@components/seo";
import Image from "next/image";
import type { GetStaticProps, NextPage } from "next/types";
import useTranslation from "next-translate/useTranslation";
import { useState } from "react";
import { PAGE } from "../consts/ppages";
import { getDocumentsPageById } from "../utils/get-page";
interface IPage {
    page: {
        title: string;
        content: string;
        documents: {
            pvc: {
                documents: {
                    name: string;
                    icon: {
                        sourceUrl: string;
                    };
                    file: {
                        mediaItemUrl: string;
                    };
                }[];
                instructions: {
                    name: string;
                    icon: {
                        sourceUrl: string;
                    };
                    file: {
                        mediaItemUrl: string;
                    };
                }[];
                guidlines: {
                    name: string;
                    icon: {
                        sourceUrl: string;
                    };
                    file: {
                        mediaItemUrl: string;
                    };
                }[];
            };
            alu: {
                documents: {
                    name: string;
                    icon: {
                        sourceUrl: string;
                    };
                    file: {
                        mediaItemUrl: string;
                    };
                }[];
                instructions: {
                    name: string;
                    icon: {
                        sourceUrl: string;
                    };
                    file: {
                        mediaItemUrl: string;
                    };
                }[];
                guidlines: {
                    name: string;
                    icon: {
                        sourceUrl: string;
                    };
                    file: {
                        mediaItemUrl: string;
                    };
                }[];
            };
            rollers: {
                documents: {
                    name: string;
                    icon: {
                        sourceUrl: string;
                    };
                    file: {
                        mediaItemUrl: string;
                    };
                }[];
                instructions: {
                    name: string;
                    icon: {
                        sourceUrl: string;
                    };
                    file: {
                        mediaItemUrl: string;
                    };
                }[];
                guidlines: {
                    name: string;
                    icon: {
                        sourceUrl: string;
                    };
                    file: {
                        mediaItemUrl: string;
                    };
                }[];
            };
            others: {
                documents: {
                    name: string;
                    icon: {
                        sourceUrl: string;
                    };
                    file: {
                        mediaItemUrl: string;
                    };
                }[];
                instructions: {
                    name: string;
                    icon: {
                        sourceUrl: string;
                    };
                    file: {
                        mediaItemUrl: string;
                    };
                }[];
                guidlines: {
                    name: string;
                    icon: {
                        sourceUrl: string;
                    };
                    file: {
                        mediaItemUrl: string;
                    };
                }[];
            };
        };
    };
}
const Documents: NextPage<IPage> = ({ page }) => {
    const { t } = useTranslation("common");
    const [openGuidelines, setOpenGuidelines] = useState({
        others: false,
    });
    const toggleGuidelines = (section: keyof typeof openGuidelines) => {
        setOpenGuidelines((prev) => ({
            ...prev,
            [section]: !prev[section],
        }));
    };
    const handleToggleOthersGuidelines = () => toggleGuidelines("others");
    return (<>
      <NextSeo languageAlternates={[
            { href: "https://knsokna.pl/documents", hrefLang: "x-default" },
            { href: "https://knswindows.com/documents", hrefLang: "en" },
            { href: "https://knsokna.pl/documents", hrefLang: "pl" },
            { href: "https://knsfenster.de/documents", hrefLang: "de" },
            { href: "https://kns-okna.eu/documents", hrefLang: "cs" },
            { href: "https://knsfinestre.it/documents", hrefLang: "it" },
            { href: "https://knsfenetres.fr/documents", hrefLang: "fr" },
            { href: "https://knsokna.eu/documents", hrefLang: "hu" },
        ]}/>
      <div className="bg-white">
        <div className="mx-auto max-w-7xl">
          <Image alt="documents" height="596" src="/img/documents.webp" width="1600"/>
        </div>
        <div className="mx-auto max-w-7xl px-2 py-2 xl:px-0">
          <div className="py-3 text-center">
            <span className="bg-gradient-to-r from-red to-orange px-3 py-1 font-bold text-lg text-white uppercase">
              {t("products.pvc")}
            </span>
          </div>
          <div className="bg-gray-100 p-2 text-sm uppercase">
            {t("downloads.documents")}
          </div>
          <Downloads2 downloads={page?.documents.pvc.documents}/>
          <div className="bg-gray-100 p-2 text-sm uppercase">
            {t("downloads.instructions")}
          </div>
          <Downloads3 downloads={page?.documents.pvc.instructions}/>
          <div className="bg-gray-100 p-2 text-sm uppercase">
            {t("downloads.guidelines")}
          </div>
          <Downloads3 downloads={page?.documents.pvc.guidlines}/>
        </div>
        <div className="mx-auto max-w-7xl px-2 py-2 xl:px-0">
          <div className="py-3 text-center">
            <span className="bg-gradient-to-r from-red to-orange px-3 py-1 font-bold text-lg text-white uppercase">
              {t("products.alu")}
            </span>
          </div>
          <div className="bg-gray-100 p-2 text-sm uppercase">
            {t("downloads.documents")}
          </div>
          <Downloads2 downloads={page?.documents.alu.documents}/>
          <div className="bg-gray-100 p-2 text-sm uppercase">
            {" "}
            {t("downloads.instructions")}
          </div>
          <Downloads3 downloads={page?.documents.alu.instructions}/>
          <div className="bg-gray-100 p-2 text-sm uppercase">
            {t("downloads.guidelines")}
          </div>
          <Downloads3 downloads={page?.documents.alu.guidlines}/>
        </div>
        <div className="mx-auto max-w-7xl px-2 py-2 xl:px-0">
          <div className="py-3 text-center">
            <span className="bg-gradient-to-r from-red to-orange px-3 py-1 font-bold text-lg text-white uppercase">
              {t("products.rollers")}
            </span>
          </div>
          <div className="bg-gray-100 p-2 text-sm uppercase">
            {t("downloads.documents")}
          </div>
          <Downloads2 downloads={page?.documents.rollers.documents}/>
          <div className="bg-gray-100 p-2 text-sm uppercase">
            {" "}
            {t("downloads.instructions")}
          </div>
          <Downloads3 downloads={page?.documents.rollers.instructions}/>
          <div className="bg-gray-100 p-2 text-sm uppercase">
            {t("downloads.guidelines")}
          </div>
          <Downloads3 downloads={page?.documents.rollers.guidlines}/>
        </div>
        <div className="mx-auto max-w-7xl px-2 py-2 xl:px-0">
          <div className="py-3 text-center">
            <span className="bg-gradient-to-r from-red to-orange px-3 py-1 font-bold text-lg text-white uppercase">
              {t("pvc.accessories")}
            </span>
          </div>
          <div className="bg-gray-100 p-2 text-sm uppercase">
            {t("downloads.documents")}
          </div>
          <Downloads2 downloads={page?.documents.others.documents}/>
          <div className="bg-gray-100 p-2 text-sm uppercase">
            {" "}
            {t("downloads.instructions")}
          </div>
          <Downloads3 downloads={page?.documents.others.instructions}/>
          <button className="flex w-full cursor-pointer items-center justify-between bg-gray-100 p-2 text-sm uppercase" onClick={handleToggleOthersGuidelines} type="button">
            <span>{t("downloads.guidelines")}</span>
            <span className="text-sm">{openGuidelines.others ? "▼" : "▶"}</span>
          </button>
          {openGuidelines.others && (<Downloads3 downloads={page?.documents.others.guidlines}/>)}
        </div>
      </div>
    </>);
};
const getStaticProps: GetStaticProps = async (context) => {
    const locale = context.locale || "PL";
    const LOCALE = locale === "cz" ? "CS" : locale.toUpperCase();
    const PAGE_ID = PAGE.DOCUMENTS[LOCALE as keyof typeof PAGE.DOCUMENTS] || 1;
    const { page } = await getDocumentsPageById(PAGE_ID);
    return {
        props: {
            page,
        },
        revalidate: 604800, // one week!
    };
};
export default Documents;

    async function __Next_Translate__getStaticProps__1a19cd2beea__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/documents',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a19cd2beea__ as getStaticProps }
  